import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Services from "@/components/landing/Services";
import Operate from "@/components/landing/Operate";
import ServiceArea from "@/components/landing/ServiceArea";
import BeforeAfter from "@/components/landing/BeforeAfter";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import Estimator from "@/components/landing/Estimator";
import QuoteForm from "@/components/landing/QuoteForm";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#FAF9F6] text-slate-900 antialiased" data-testid="acpm-landing-page">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Operate />
        <ServiceArea />
        <BeforeAfter />
        <Testimonials />
        <Faq />
        <Estimator />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
